import {useEffect} from 'react';
const windows: any = window;
export const FeatureFlags = {
  enableTranscription: process.env.REACT_APP_ENABLE_TRANSCRIPTION === 'true',
  enableStatsForNerds: process.env.REACT_APP_ENABLE_STATS_FOR_NERDS === 'true',
  enableWhiteboard:
    process.env.REACT_APP_ENABLE_WHITEBOARD &&
    process.env.REACT_APP_PUSHER_APP_KEY &&
    process.env.REACT_APP_PUSHER_AUTHENDPOINT,

  init: () => {
    if (!windows) {
      windows.HMS = {} as any;
    }
    windows.HMS = {} as any;
    // unsubscribe for muted audio tracks
    windows.HMS.AUDIO_SINK = false;
    // some extra config to hls js to bring down latency
    windows.HMS.OPTIMISE_HLS_LATENCY = false;
    // ask permissions in preview even if role doesn't have it
    windows.HMS.ALWAYS_REQUEST_PERMISSIONS = false;
    // add support for server degradation
    windows.HMS.FREEZE_VIDEO_LIST = false; // process.env.REACT_APP_ENV === "qa";
    // to send http events
    windows.HMS.CLIENT_EVENTS = process.env.SEND_CLIENT_EVENTS === 'true';
  },

  freezeVideoList: () => {
    return windows.HMS.FREEZE_VIDEO_LIST;
  },
  optimiseHLSLatency: () => {
    return windows.HMS.OPTIMISE_HLS_LATENCY;
  },

  alwaysRequestPermissions: () => {
    return windows.HMS.ALWAYS_REQUEST_PERMISSIONS;
  },
};

export function FeatureFlagsInit() {
  useEffect(() => {
    FeatureFlags.init();
  }, []);
  return null;
}
